import React from 'react';

export default function Logo({ size = 36, className = '', withWordmark = false }) {
  return (
    <span
      className={`inline-flex items-center gap-3 ${className}`}
      data-testid="alpha7-logo"
    >
      <img
        src="/alpha7-logo-dark.png"
        srcSet="/alpha7-logo-dark.png 1x, /alpha7-logo-dark@2x.png 2x"
        alt="ALPHA 7"
        style={{ height: `${size}px`, width: 'auto', display: 'block' }}
        draggable="false"
      />
    </span>
  );
}
